module.exports = __webpack_public_path__ + "static/media/campo1.6a5e6daf.jpg";